// src/Components/Forms/Financement/Salam/Demande/Tab3.tsx
import React, { useEffect, useState } from 'react';
import Params from '../../../../../Types/ParamsPicklist';
import { Box, Grid } from '@mui/material';
import { useAuthHeader } from '../../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import DataType from '../../../../../Types/DataTablePiclist';
import Datas from '../../../../../Data/Data.json';
import SelectMultipleOptionPanier from '../../../../SelectMultipleOptionPanier';

// Paramètre de recherche pour les opérations (frais de gestion)
let searchOperat: Params = {
  CodeAgence: '',
  Table: "OPERAT",
  Colonne1: "CODOPE",
  Colonne2: "LIBELL",
  Colagence: '101',
  Choix: 22
};

interface Tab3Props {
  form?: any;
  fraisOptions: { value: string; label: string }[];
  fraisSelectionnes: string[];
  setFraisSelectionnes: React.Dispatch<React.SetStateAction<string[]>>;
}

function Tab3({ form, fraisOptions, fraisSelectionnes, setFraisSelectionnes }: Tab3Props) {
  const authHeader = useAuthHeader();
  const [data, setData] = useState<DataType[]>([]);
  const [loading, setLoading] = useState(false);

  // Appel API contrôlé dans useEffect avec nettoyage
  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    const config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(searchOperat))
      }
    };

    axios(config)
      .then((response) => {
        if (cancelled || !response.data) return;
        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
        if (res.StatutCode === 200) {
          const datas = res.Result.Table ?? [];
          setData(datas.map((d: any, index: number) => ({
            key: index,
            Code: d[Object.keys(d)[1]],
            Libelle: d[Object.keys(d)[0]],
          })));
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; }; // évite setState après démontage
  }, [authHeader]);

  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width={"85%"} position={"absolute"}>
        <Grid item xs={12} md={12} lg={12}>
          <SelectMultipleOptionPanier
            notRequired
            disabled
            form={form}
            Size="large"
            width={4}
            label="Frais de gestion"
            name="CodeFrais"
            Parametre={searchOperat}
          />
        </Grid>
      </Box>
    </div>
  );
}

export default Tab3;